/**
 * The Flowers Directory — Cart & Checkout Override
 *
 * Intercepts Shopify's Add to Cart and routes orders through
 * the Florist One API via Cloudflare Worker proxy.
 *
 * How it works:
 * 1. On product/collection pages, intercepts form[action="/cart/add"]
 * 2. Reads the Florist One code from window.TFD_PRODUCTS map
 * 3. Adds the item to a Florist One cart (server-side session)
 * 4. Shows a slide-out cart panel
 * 5. Checkout redirects to /pages/checkout
 */
(function () {
  'use strict';

  var CONFIG = window.TFD_CONFIG || {};
  var API_BASE = CONFIG.apiBase || '';
  var CHECKOUT_URL = '/pages/checkout';

  var state = {
    cartSessionId: null,
    cartItems: [],
    cartCount: 0,
    productImages: {},
  };

  // Restore from localStorage
  try {
    state.cartSessionId = localStorage.getItem('tfd_cart_session') || null;
    state.productImages = JSON.parse(localStorage.getItem('tfd_product_images') || '{}');
    state.cartCount = parseInt(localStorage.getItem('tfd_cart_count') || '0', 10);
  } catch (e) {}

  // Keep first-touch evidence separately from the active paid click.
  // A later ad in the same tab replaces only the active context; ordinary
  // navigation, reloads and back/forward history retain the current click.
  var attributionFallback = {
    entry: document.referrer || '(direct)',
    landing: window.location.pathname + window.location.search,
  };
  function paidClickKey(path) {
    var q = new URLSearchParams((path || '').split('?').slice(1).join('?'));
    return ['gclid', 'gbraid', 'wbraid'].map(function (k) {
      return q.get(k) ? k + '=' + q.get(k) : '';
    }).filter(Boolean).join('&');
  }
  function attributionContext() {
    try {
      return {
        entry: sessionStorage.getItem('tfd_entry') || attributionFallback.entry,
        landing: sessionStorage.getItem('tfd_landing') || attributionFallback.landing,
      };
    } catch (e) { return attributionFallback; }
  }
  try {
    var currentLanding = attributionFallback.landing;
    var p = new URLSearchParams(window.location.search);
    var utm = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','q','query','search',
      'gclid','gbraid','wbraid','fbclid','msclkid']
      .map(function (k) { var v = p.get(k); return v ? k + '=' + v : null; })
      .filter(Boolean).join('&');
    attributionFallback.entry += utm ? ' | ' + utm : '';
    var storedLanding = sessionStorage.getItem('tfd_landing') || '';
    var storedEntry = sessionStorage.getItem('tfd_entry') || '';
    var paid = /[?&](gclid|gbraid|wbraid)=|[?&]utm_medium=(cpc|ppc|paid)(&|$)/i;
    var incomingKey = paidClickKey(currentLanding);
    var storedKey = paidClickKey(storedLanding);
    var navigation = performance.getEntriesByType('navigation')[0];
    var historyReturn = navigation && navigation.type === 'back_forward';
    var incomingCampaign = p.get('utm_campaign') || '';
    var storedCampaign = new URLSearchParams(storedLanding.split('?').slice(1).join('?')).get('utm_campaign') || '';
    var newPaidClick = paid.test(currentLanding) && !historyReturn &&
      (incomingKey ? incomingKey !== storedKey : !paid.test(storedLanding) || incomingCampaign !== storedCampaign);
    if (!sessionStorage.getItem('tfd_first_entry')) {
      sessionStorage.setItem('tfd_first_entry', storedEntry || attributionFallback.entry);
      sessionStorage.setItem('tfd_first_landing', storedLanding || currentLanding);
    }
    if (!storedEntry || !storedLanding || newPaidClick) {
      sessionStorage.setItem('tfd_entry', attributionFallback.entry);
      sessionStorage.setItem('tfd_landing', currentLanding);
      if (newPaidClick) sessionStorage.removeItem('tfd_vid');
    } else {
      attributionFallback.entry = storedEntry;
      attributionFallback.landing = storedLanding;
    }
  } catch (e) { /* blocked storage retains the in-memory current landing */ }


  // Funnel events -> tfd-cro /api/tfd-funnel (funnel_events). The visit's landing URL goes
  // with each one, so a Google Ads visit carries its keyword (utm_term) and click ID.
  // Page views are sent only for visits that began on an ad click.
  var PAID_RE = /[?&](gclid|gbraid|wbraid)=|[?&]utm_medium=(cpc|ppc|paid)(&|$)/i;
  function visitId() {
    try {
      var v = sessionStorage.getItem('tfd_vid');
      if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem('tfd_vid', v); }
      return v;
    } catch (e) { return ''; }
  }
  function trackFunnel(type, data) {
    try {
      var payload = { t: type, sid: visitId(), page: location.pathname + location.search,
        landing: attributionContext().landing, entry: attributionContext().entry };
      for (var k in (data || {})) payload[k] = data[k];
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon && navigator.sendBeacon('/api/tfd-funnel', body)) return;
      fetch('/api/tfd-funnel', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // Time on page and scroll depth for ad visits: a page_exit event each time the tab is
  // hidden (leaving, switching tabs, locking the phone), with the seconds this page was
  // visible and the deepest scroll so far. Values are cumulative for the page load (pv).
  function trackEngagement() {
    var pv = Math.random().toString(36).replace(/[^a-z]/g, '').slice(0, 8);
    var visibleMs = 0, sent = '', maxScroll = 0;
    var since = document.visibilityState === 'visible' ? Date.now() - Math.round(performance.now()) : 0;
    function onScroll() {
      var el = document.documentElement;
      var h = Math.max(el.scrollHeight, document.body ? document.body.scrollHeight : 0);
      var p = h ? Math.min(100, Math.round(100 * ((window.scrollY || 0) + window.innerHeight) / h)) : 0;
      if (p > maxScroll) maxScroll = p;
    }
    function flush() {
      if (since) { visibleMs += Date.now() - since; since = 0; }
      var sec = Math.round(visibleMs / 1000);
      if (sent === sec + ':' + maxScroll) return;
      sent = sec + ':' + maxScroll;
      trackFunnel('page_exit', { value: sec, detail: 'scroll=' + maxScroll + ' pv=' + pv });
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
      else if (!since) since = Date.now();
    });
    window.addEventListener('pagehide', flush);
  }
  try {
    if (PAID_RE.test(attributionContext().landing)) {
      trackFunnel('page_view');
      trackEngagement();
    }
  } catch (e) {}

  // ============================================================
  // API
  // ============================================================

  function apiFetch(path, options) {
    options = options || {};
    var url = API_BASE + path;
    var qs = [];
    if (options.params) {
      Object.keys(options.params).forEach(function (k) {
        var v = options.params[k];
        if (v != null) qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
    }
    if (qs.length) url += '?' + qs.join('&');

    var headers = options.headers || {};
    headers['X-TFD-Referrer'] = window.location.pathname;
    try {
      var entry = attributionContext().entry;
      var landing = attributionContext().landing;
      if (entry) headers['X-TFD-Entry'] = entry;
      if (landing) headers['X-TFD-Landing'] = landing;
    } catch (e) {}

    return fetch(url, {
      method: options.method || 'GET',
      headers: headers,
      body: options.body,
    }).then(function (resp) {
      return resp.json().then(function (data) {
        if (data.errors && data.errors.length) throw new Error(data.errors.join(', '));
        return data;
      });
    });
  }

  // ============================================================
  // Cart Operations
  // ============================================================

  function addToCart(foCode, productName, productPrice, productImage) {
    // Cache product info for cart display
    if (productImage) {
      state.productImages[foCode] = productImage;
      try { localStorage.setItem('tfd_product_images', JSON.stringify(state.productImages)); } catch (e) {}
    }

    var createAndAdd = function () {
      return apiFetch('/cart', { method: 'POST' }).then(function (cart) {
        state.cartSessionId = cart.SESSIONID;
        try { localStorage.setItem('tfd_cart_session', state.cartSessionId); } catch (e) {}
        return doAdd();
      });
    };

    var doAdd = function () {
      return apiFetch('/cart', {
        method: 'PUT',
        params: { sessionid: state.cartSessionId, action: 'add', productcode: foCode },
      });
    };

    var chain;
    if (!state.cartSessionId) {
      chain = createAndAdd();
    } else {
      chain = doAdd().catch(function () { return createAndAdd(); });
    }

    return chain.then(function () {
      // Dynamic remarketing: only the everyday design on its own product page.
      // window.TFD_RMK_ITEM is set by product-details.liquid, never on sympathy products.
      var rmk = window.TFD_RMK_ITEM;
      if (rmk && rmk.id === foCode && typeof window.gtag === 'function') {
        try {
          window.gtag('event', 'add_to_cart', { send_to: 'AW-18479150734', value: rmk.price, currency: 'USD',
            items: [{ id: rmk.id, google_business_vertical: 'retail' }] });
        } catch (e) {}
      }
      return refreshCart();
    });
  }

  function removeFromCart(index) {
    if (!state.cartSessionId) return Promise.resolve();
    return apiFetch('/cart', {
      method: 'PUT',
      params: { sessionid: state.cartSessionId, action: 'remove', itemindex: index },
    }).then(function () { return refreshCart(); });
  }

  function refreshCart() {
    if (!state.cartSessionId) {
      state.cartItems = [];
      state.cartCount = 0;
      updateBadge();
      return Promise.resolve();
    }
    return apiFetch('/cart', { params: { sessionid: state.cartSessionId } })
      .then(function (data) {
        state.cartItems = data.products || [];
        state.cartCount = data.productcount || state.cartItems.length;
        updateBadge();
      })
      .catch(function () {
        state.cartItems = [];
        state.cartCount = 0;
        state.cartSessionId = null;
        try { localStorage.removeItem('tfd_cart_session'); localStorage.removeItem('tfd_cart_count'); } catch (e) {}
        updateBadge();
      });
  }

  // ============================================================
  // Cart Badge (floating indicator)
  // ============================================================

  function createBadge() {
    var badge = document.createElement('div');
    badge.id = 'tfd-floating-cart';
    badge.innerHTML =
      '<button id="tfd-floating-cart-btn">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">' +
          '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
          '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
        '</svg>' +
        '<span id="tfd-cart-count">0</span>' +
      '</button>';
    document.body.appendChild(badge);

    badge.querySelector('button').addEventListener('click', function () {
      openCartPanel();
    });
  }

  function updateBadge() {
    var countEl = document.getElementById('tfd-cart-count');
    if (countEl) {
      countEl.textContent = state.cartCount;
      var btn = document.getElementById('tfd-floating-cart');
      if (btn) btn.style.display = state.cartCount > 0 ? '' : 'none';
    }
    // Persist count so it shows immediately on next page load
    try { localStorage.setItem('tfd_cart_count', String(state.cartCount)); } catch (e) {}
    // Also update any theme cart count badges
    document.querySelectorAll('.cart-count, .cart-link__count, [data-cart-count]').forEach(function (el) {
      el.textContent = state.cartCount || '';
    });
  }

  // ============================================================
  // Cart Panel (slide-out)
  // ============================================================

  function openCartPanel() {
    closeCartPanel();

    // Hide chat widget so it doesn't cover checkout button
    var chatBubble = document.getElementById('tfd-cw-bubble');
    if (chatBubble) chatBubble.style.display = 'none';

    var items = state.cartItems;
    var subtotal = items.reduce(function (s, p) { return s + p.PRICE; }, 0);

    var itemsHTML;
    if (!items.length) {
      itemsHTML = '<div class="tfd-cart-empty"><p>Your cart is empty</p></div>';
    } else {
      itemsHTML = items.map(function (item, i) {
        var img = state.productImages[item.CODE] || '';
        return '<div class="tfd-cart-item">' +
          '<div class="tfd-cart-item-image">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.NAME) + '">' : '') +
          '</div>' +
          '<div class="tfd-cart-item-info">' +
            '<p class="tfd-cart-item-name">' + esc(item.NAME) + '</p>' +
            '<p class="tfd-cart-item-price">$' + item.PRICE.toFixed(2) + '</p>' +
            '<button class="tfd-cart-item-remove" data-remove-index="' + i + '">Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    var overlay = document.createElement('div');
    overlay.className = 'tfd-cart-overlay';
    overlay.id = 'tfd-cart-overlay';
    overlay.addEventListener('click', closeCartPanel);
    document.body.appendChild(overlay);

    var panel = document.createElement('div');
    panel.className = 'tfd-cart-panel';
    panel.id = 'tfd-cart-panel';
    panel.innerHTML =
      '<div class="tfd-cart-header">' +
        '<h2>Your Cart (' + items.length + ')</h2>' +
        '<button class="tfd-cart-close" id="tfd-close-cart">&times;</button>' +
      '</div>' +
      '<div class="tfd-cart-items">' + itemsHTML + '</div>' +
      (items.length ?
        '<div class="tfd-cart-footer">' +
          '<div class="tfd-cart-subtotal"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
          '<p class="tfd-cart-note">Delivery charges and tax calculated at checkout</p>' +
          '<a href="' + CHECKOUT_URL + '" class="tfd-btn tfd-btn-primary" style="display:block;text-align:center;text-decoration:none">Proceed to Checkout</a>' +
        '</div>'
      : '');

    document.body.appendChild(panel);

    // Event handlers
    panel.querySelector('#tfd-close-cart').addEventListener('click', closeCartPanel);

    panel.querySelectorAll('[data-remove-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.removeIndex);
        removeFromCart(idx).then(function () {
          closeCartPanel();
          if (state.cartItems.length) openCartPanel();
        });
      });
    });

    document.addEventListener('keydown', escHandler);
  }

  function closeCartPanel() {
    var overlay = document.getElementById('tfd-cart-overlay');
    var panel = document.getElementById('tfd-cart-panel');
    if (overlay) overlay.remove();
    if (panel) panel.remove();
    document.removeEventListener('keydown', escHandler);

    // Restore chat widget
    var chatBubble = document.getElementById('tfd-cw-bubble');
    if (chatBubble) chatBubble.style.display = 'flex';
  }

  function escHandler(e) {
    if (e.key === 'Escape') closeCartPanel();
  }

  // ============================================================
  // Add to Cart Interception
  // ============================================================

  function interceptAddToCart() {
    // Intercept all add-to-cart form submissions.
    // Capture phase (3rd arg `true`) so this runs BEFORE the theme's own
    // data-ajax-add-to-cart handler, which binds in the bubble phase. Without
    // this, the theme wins the race and adds the raw Shopify variant to the
    // native cart/checkout, bypassing Florist One entirely.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;

      // Get the Shopify variant ID from the form
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      var variantId = variantInput.value;

      // Look up Florist One code from the map injected by Liquid
      var foCode = (window.TFD_PRODUCTS || {})[variantId];
      if (!foCode) return; // Not a synced product, let Shopify handle it

      // Prevent Shopify's add to cart AND stop the theme's ajax-cart handler
      // from also firing (it would add to the native cart at the wrong price).
      e.preventDefault();
      e.stopImmediatePropagation();

      var info = readProductInfo();
      var productName = info.name;
      var productPrice = info.price;
      var productImage = info.image;

      // Show feedback
      var submitBtn = form.querySelector('[type="submit"], button:not([type])');
      var origText = '';
      if (submitBtn) {
        origText = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
      }

      addToCart(foCode, productName, productPrice, productImage).then(function () {
        if (submitBtn) {
          submitBtn.textContent = 'Added!';
          setTimeout(function () {
            submitBtn.textContent = origText;
            submitBtn.disabled = false;
          }, 1500);
        }
        openCartPanel();
      }).catch(function (err) {
        console.error('TFD: Failed to add to cart:', err);
        if (submitBtn) {
          submitBtn.textContent = origText;
          submitBtn.disabled = false;
        }
        alert('Could not add to cart. Please try again.');
      });
    }, true);

    // Also intercept AJAX add-to-cart (Shopify themes often use fetch/XHR)
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (url, options) {
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.body) {
          var body;
          try {
            if (typeof options.body === 'string') body = JSON.parse(options.body);
            else if (options.body instanceof FormData) {
              body = {};
              options.body.forEach(function (v, k) { body[k] = v; });
            }
          } catch (e) {}

          if (body && body.id) {
            var foCode = (window.TFD_PRODUCTS || {})[body.id];
            if (foCode) {
              return addToCart(foCode, '', 0, '').then(function () {
                openCartPanel();
                return new Response(JSON.stringify({ ok: true }), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' },
                });
              });
            }
          }
        }
        return originalFetch.apply(this, arguments);
      };
    }
  }

  // ============================================================
  // Override Shopify Cart Link
  // ============================================================

  function overrideCartLinks() {
    // Intercept /cart and /checkout links — redirect to FO flow
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="/cart"], a[href="/checkout"]');
      if (!link) return;
      e.preventDefault();
      var href = link.getAttribute('href');
      if (href === '/checkout') {
        window.location.href = CHECKOUT_URL;
      } else {
        openCartPanel();
      }
    });

    // Update any cart count badges in the theme
    var themeCartCounts = document.querySelectorAll('.cart-count, .cart-link__count, [data-cart-count]');
    themeCartCounts.forEach(function (el) {
      var observer = new MutationObserver(function () {
        el.textContent = state.cartCount || '';
      });
      // Update now
      if (state.cartCount > 0) el.textContent = state.cartCount;
    });
  }

  // ============================================================
  // Product page helpers
  // ============================================================

  // Name, price and image as displayed on the current product page.
  function readProductInfo() {
    var name = '';
    var price = 0;
    var image = '';

    var nameEl = document.querySelector('.product-title, [data-product-title], h1.product-area__title, h1');
    if (nameEl) name = nameEl.textContent.trim();

    var priceEl = document.querySelector('.product-price .money, .current-price .money, [data-product-price]');
    if (priceEl) {
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      price = parseFloat(priceText) || 0;
    }

    // Showcase theme: full-size URL on .theme-img container
    var themeImg = document.querySelector('.theme-img.current-img[data-full-size]');
    if (themeImg) {
      image = themeImg.getAttribute('data-full-size');
    }
    // Fallback: lazy-loaded img with data-src (replace width placeholder)
    if (!image) {
      var lazyImg = document.querySelector('.product-media--image img[data-src]');
      if (lazyImg) image = lazyImg.getAttribute('data-src').replace('_{width}x.', '_300x.');
    }
    // Fallback: any img in the product media area
    if (!image) {
      var anyImg = document.querySelector('.product-area__media img[src]');
      if (anyImg) image = anyImg.src;
    }

    return { name: name, price: price, image: image };
  }

  // ?add=1 on a product page adds it to the Florist One cart and opens the
  // panel, so a link from an AI agent (see the MCP get_checkout_link tool)
  // lands one click from checkout. Runs once per tab per variant; the flag
  // is stripped from the address bar so reloads, back/forward and shared
  // links do not add a second copy.
  function autoAddFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('add') !== '1') return;
      if (!/^\/products\//.test(window.location.pathname)) return;

      var form = document.querySelector('form[action="/cart/add"]');
      var variantInput = form && form.querySelector('[name="id"]');
      if (!variantInput) return;
      var variantId = variantInput.value;
      var foCode = (window.TFD_PRODUCTS || {})[variantId];
      if (!foCode) return;

      var guardKey = 'tfd_auto_added_' + variantId;
      try {
        if (sessionStorage.getItem(guardKey)) return;
        sessionStorage.setItem(guardKey, '1');
      } catch (e) {}

      try {
        params.delete('add');
        var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
        window.history.replaceState(null, '', clean);
      } catch (e) {}

      var info = readProductInfo();
      addToCart(foCode, info.name, info.price, info.image).then(function () {
        openCartPanel();
      }).catch(function (err) {
        console.error('TFD: auto-add failed:', err);
      });
    } catch (e) {
      console.error('TFD: auto-add skipped:', e);
    }
  }

  // ============================================================
  // Utility
  // ============================================================

  function esc(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // ============================================================
  // Init
  // ============================================================

  function init() {
    createBadge();
    interceptAddToCart();
    overrideCartLinks();
    // Auto-add waits for the initial cart read so the two never race.
    refreshCart().then(autoAddFromUrl, autoAddFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
